import React, { useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const testimonials = [
  {
    quoteImg: "/assets/img/shape/quote1.png", // Keep your quote image path here
    rating: 5, // Adjust rating if needed
    text: "At City Life Vacation Homes, we are dedicated to providing our guests with the best possible stay. Whether you're here for business or leisure, we aim to offer you a home-away-from-home experience with top-notch amenities, comfort, and excellent customer service. We strive to ensure that your stay with us is both memorable and enjoyable.",
    avatar: "/assets/img/testimonial/user.jpg", // Update with your actual image
    name: "MR XYZ", // Managing Director's name
    designation: "Managing Director", // Your designation
  },
];

const ChairmanSection = () => {
  const mainSlider = useRef(null);
  const navSlider = useRef(null);

  const settingsMain = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    asNavFor: navSlider.current,
  };

  return (
    <section
      className="space testimonial-style1 home_testimonial"
      style={{
        backgroundImage: "url(/assets/img/bg/testimonial-bg.jpg)", // Ensure the correct background image is used
      }}
    >
      <div className="container">
        <div className="row justify-content-between align-items-center">
          <div className="col-xxl-5 col-xl-5">
            <div className="title-area">
              <span className="sec-subtitle">City Life Vacation Homes</span>
              <h2 className="sec-title h1">
                A Message From Our Managing Director
              </h2>
              <p className="sec-text">
                Welcome to City Life Vacation Homes! It’s our pleasure to offer
                you the best experience during your stay in Dubai. We are
                committed to providing quality, comfort, and memorable stays for
                every guest.
              </p>
            </div>
          </div>
          <div className="col-xxl-6 col-xl-7">
            <div className="testi-style1">
              <div className="testi-shape"></div>
              <Slider
                {...settingsMain}
                className="vs-carousel"
                id="testId"
                ref={mainSlider}
              >
                {testimonials.map((testimonial, index) => (
                  <div key={index} className="position-relative z-index-common">
                    <div className="testi-quote">
                      <img src={testimonial.quoteImg} alt="quote" />
                    </div>

                    <p className="testi-text">{testimonial.text}</p>
                    <div className="testi-avater d-flex justify-content-center align-items-center">
                      <img src={testimonial.avatar} alt="customer" />
                    </div>
                    <h3 className="testi-name">{testimonial.name}</h3>
                    <span className="testi-degi">
                      {testimonial.designation}
                    </span>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ChairmanSection;
